<template>
  <b-overlay :show="isLoading">
    <b-row v-if="masterLevelDetails">
      <b-col cols="12">
        <b-card>
          <h1 class="mb-3">ویرایش سطح اساتید</h1>
          <b-row>
            <b-col cols="12">
              <b-form-group label="عنوان سطح" label-for="title">
                <b-form-input
                  v-model="masterLevelDetails.title"
                  id="title"
                  trim
                  placeholder="برای مثال برنز"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group
                label="از چند ساعت در هفته (برای مثال از 4 ساعت)"
                label-for="fromHour"
              >
                <b-form-input
                  v-model="masterLevelDetails.fromHour"
                  id="fromHour"
                  trim
                  type="number"
                  placeholder="4"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group
                label="تا چند ساعت در هفته (برای مثال تا 6 ساعت)"
                label-for="toHour"
              >
                <b-form-input
                  v-model="masterLevelDetails.toHour"
                  id="toHour"
                  trim
                  type="number"
                  placeholder="6"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group
                label="نسبت درآمد استاد در این سطح به قیمت پایه (به درصد)"
                label-for="percent"
              >
                <b-input-group append="%">
                  <b-input-group-prepend is-text>
                    <b-form-checkbox v-model="hasMaxPrice">
                      <small style="margin-right: 4px">
                        حداکثر مبلغ دارد؟
                      </small>
                    </b-form-checkbox>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="masterLevelDetails.percent"
                    id="percent"
                    trim
                    type="number"
                    placeholder="6"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group
                label="حداکثر مبلغ با توجه به درصد"
                label-for="maxPrice"
              >
                <b-form-input
                  :disabled="!hasMaxPrice"
                  v-model="masterLevelDetails.maxPrice"
                  id="maxPrice"
                  trim
                  type="number"
                  placeholder="50000"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group
                label="نسبت پرداختی زبان آموز به قیمت پایه (به درصد)"
                label-for="userPercent"
              >
                <b-form-input
                  v-model="masterLevelDetails.userPercent"
                  id="userPercent"
                  trim
                  type="number"
                  placeholder="6"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group
                label="تعداد هفته‌ی مورد نیاز در این سطح برای رفتن به سطح بعدی"
                label-for="weekCount"
              >
                <b-form-input
                  v-model="masterLevelDetails.weekCount"
                  id="weekCount"
                  trim
                  type="number"
                  placeholder="6"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="رنگ سطح استاد" label-for="colorCode">
                <b-input-group size="lg" :append="masterLevelDetails.colorCode">
                  <b-form-input
                    v-model="masterLevelDetails.colorCode"
                    id="colorCode"
                    trim
                    type="color"
                    placeholder="3"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="آیا این سطح بج دارد؟" label-for="showSvg">
                <b-form-checkbox
                  id="showSvg"
                  name="check-button"
                  switch
                  v-model="masterLevelDetails.showSVG"
                >
                  <small style="margin-left: 3px">
                    {{ masterLevelDetails.showSVG ? "بله" : "خیر" }}
                  </small>
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="بج استاد" label-for="svg">
                <b-form-file
                  ref="svgFile"
                  id="svg"
                  v-model="masterLevelDetails.SVGFile"
                  accept=".jpg,.jpeg,.png,.svg"
                  @input="handleImageFile"
                ></b-form-file>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6" v-if="masterLevelDetails.svg">
              <div class="d-flex flex-column align-items-center">
                <small>عکس فعلی</small>
                <img
                  style="
                    max-height: 10rem;
                    max-width: auto;
                    object-fit: contain;
                  "
                  :src="`${this.baseUrl}/${masterLevelDetails.svg}`"
                />
              </div>
            </b-col>
            <b-col cols="12" md="6" v-if="imagePreview">
              <div class="d-flex flex-column align-items-center">
                <div class="d-flex align-items-center justify-content-between">
                  <small>پیشنمایش</small>
                  <b-button variant="transparent" @click="removePreviewImage">
                    <feather-icon
                      icon="Trash2Icon"
                      size="20"
                      class="text-danger"
                    />
                  </b-button>
                </div>
                <img
                  style="
                    max-height: 10rem;
                    max-width: auto;
                    object-fit: contain;
                  "
                  :src="imagePreview"
                  alt=""
                />
              </div>
            </b-col>
            <b-col cols="12">
              <b-form-group label="توضیحات سطح" label-for="description">
                <b-form-textarea
                  placeholder="توضیحات سطح اساتید"
                  id="description"
                  trim
                  v-model="masterLevelDetails.description"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-checkbox v-model="masterLevelDetails.canUseCustomePrice">
                <small>آیا این سطح قیمت شخصی سازی شده دارد؟</small>
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="d-flex align-items-center justify-content-end"
            >
              <b-button
                @click="updateMasterLevel"
                variant="success"
                :disabled="isEditButtonDisabled"
              >
                ویرایش
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
export default {
  mounted() {
    this.getASingleMasterLevel();
  },
  data() {
    return {
      isLoading: false,
      masterLevelDetails: null,
      hasMaxPrice: false,
      imagePreview: null,
      imageItself: null,
    };
  },
  methods: {
    removePreviewImage() {
      URL.revokeObjectURL(this.imagePreview);
      this.imagePreview = null;
      this.imageItself = null;
      this.$refs.svgFile.value = "";
    },
    handleImageFile() {
      if (this.$refs.svgFile) {
        this.imageItself = this.$refs.svgFile.files[0];
        this.imagePreview = URL.createObjectURL(this.imageItself);
      }
    },
    async updateMasterLevel() {
      try {
        this.isLoading = true;

        // Set maxprice to null if user has not check the checkbox
        // For maxprice
        if (!this.hasMaxPrice) {
          this.masterLevelDetails.maxPrice = null;
        }
        let myFormData = new FormData();
        Object.keys(this.masterLevelDetails).forEach((key) => {
          if (this.masterLevelDetails[key]) {
            myFormData.append(key, this.masterLevelDetails[key]);
          }
        });
        let _this = this;
        let updateAMasterLevel = new UpdateAMasterLevel(_this);
        updateAMasterLevel.setFormData(myFormData);
        await updateAMasterLevel.sendFormData((res) => {
          if (res.data.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "سطح استاد با موفقیت ویرایش شد.",
              },
            });
            _this.removePreviewImage();
            _this.getASingleMasterLevel();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: res.data.errors || "لطفا دوباره تلاش کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getASingleMasterLevel() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAMasterLevel = new GetAMasterLevel(_this);
        getAMasterLevel.setRequestParam({ id: _this.$route.params.id });
        await getAMasterLevel.fetch((res) => {
          _this.masterLevelDetails = res;
          if (
            _this.masterLevelDetails.maxPrice &&
            _this.masterLevelDetails.maxPrice > 0
          ) {
            _this.hasMaxPrice = true;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    isEditButtonDisabled() {
      if (
        this.masterLevelDetails &&
        (!this.masterLevelDetails.title ||
          this.masterLevelDetails.fromHour == null ||
          !this.masterLevelDetails.toHour ||
          !this.masterLevelDetails.description)
      ) {
        return true;
      }
      return false;
    },
    baseUrl() {
      return process.env.VUE_APP_BASE_URL;
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    BFormCheckbox,
    BFormRadio,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BInputGroup,
    BFormTextarea,
    BInputGroupPrepend,
    BFormFile,
  },
};
import {
  GetAMasterLevel,
  UpdateAMasterLevel,
} from "@/libs/Api/ScheduleMasterRegular";
import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormCheckbox,
  BFormRadio,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
  BInputGroup,
  BFormTextarea,
  BInputGroupPrepend,
  BFormFile,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
</script>
